<template>
  <div class="full-height">
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">
          {{
            formData.hasOwnProperty("name") && formData.name
              ? formData.name
              : "Source"
          }}
        </div>
        <q-space></q-space>
        <!-- <q-btn
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="save"
        >
          Save
        </q-btn> -->
        <q-btn
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          class="q-mr-sm sustainability-button"
          @click="save(false, true)"
        >
          Save & Add New
        </q-btn>
        <q-btn
          color="primary"
          style="width: 100px"
          :loading="isLoading"
          class="q-mr-sm sustainability-button"
          @click="save(true, false)"
        >
          Save & Close
        </q-btn>

        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section class="q-pa-none">
        <q-tabs v-model="tab" align="left">
          <q-tab v-for="(tabItem, i) in tabsList" :key="i" :name="tabItem.name">
            <div style="display: inline">
              <span class="tabTitle">{{ tabItem.label }} </span>
              <q-icon
                name="mdi-alert-circle"
                color="red"
                v-if="tabItem.isError"
              >
              </q-icon>
            </div>
          </q-tab>
        </q-tabs>

        <q-tab-panels v-model="tab" animated keep-alive ref="tabs">
          <!---GENERAL-->
          <q-tab-panel name="general">
            <div class="row q-mb-sm items-center q-mt-none">
              <div class="col-12">
                <div class="title q-my-none">
                  Source Specific
                  <div
                    style="width: 100px; display: inline-block"
                    class="q-px-sm"
                  >
                    <q-select
                      label="Type"
                      :options="['data', 'scale']"
                      v-model="formData.type"
                      :rules="[(v) => !!v || 'Type is required']"
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-grey">
                            No results
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <span class="text-grey" style="max-width: 600px">
                This is the image used as the stock image default for Sources.
                It often shows up in reports when someone has created a data
                goal. Please make it slightly different than the image below
              </span>
            </div>
            <q-form ref="form">
              <div class="row q-my-sm">
                <!-- IMG Section -->
                <div class="col-auto q-pa-sm">
                  <div
                    v-if="
                      (sourceChangeImage || !formData.imageUrl) && formData.id
                    "
                  >
                    <div style="width: 300px">
                      <croppa
                        ref="imgCroppa"
                        :height="200"
                        :width="300"
                        v-model="sourceMyCroppa"
                        remove-button-color="#68c6d2"
                        :show-loading="true"
                        :loading-size="50"
                        crossOrigin="anonymous"
                        :quality="2"
                        :prevent-white-space="false"
                      ></croppa>
                    </div>
                    <span class="text-caption">
                      Recommended .jpg/.jpeg files and ideally 500Kb
                    </span>
                  </div>
                  <div v-else style="width: 300px; margin: auto">
                    <q-img
                      :src="formData.imageUrl"
                      style="width: 300px; height: 200px"
                      v-if="formData.id"
                    >
                    </q-img>
                    <q-btn
                      class="full-width"
                      color="primary"
                      label="Change"
                      @click="sourceChangeImage = true"
                      v-if="formData.id"
                    >
                    </q-btn>
                    <span class="text-caption"
                      >Recommended .jpg/.jpeg files and ideally 500Kb
                    </span>
                  </div>
                </div>
                <!-- Info Box Section -->
                <div class="col q-pa-sm">
                  <div class="row q-col-gutter-y-lg">
                    <div class="col-4 q-px-sm">
                      <q-input
                        v-model="formData.name"
                        label="Source name"
                        :rules="[(v) => !!v || 'Name is Required']"
                      ></q-input>
                    </div>
                    <div class="col-4">
                      <q-input
                        v-model="formData.hoverField"
                        label="Hover Field"
                        hint="This will show when you hover a source title"
                      >
                      </q-input>
                    </div>
                    <div v-if="formData.type != 'scale'" class="col-4 q-px-sm">
                      <q-select
                        label="Unit"
                        :options="filteredUnitsList"
                        option-label="name"
                        option-value="id"
                        map-options
                        emit-value
                        @filter="filterUnits"
                        v-model="formData.sourcesUnits_id"
                        :rules="[(v) => !!v || 'Unit is required']"
                      >
                        <template v-slot:no-option>
                          <q-item>
                            <q-item-section class="text-grey">
                              No results
                            </q-item-section>
                          </q-item>
                        </template>
                      </q-select>
                    </div>
                    <div
                      class="col-12 col-sm-6 q-px-sm"
                      v-if="formData.type == 'data'"
                    >
                      <!-- {{ sourceList }} -->
                      <Autocomplete
                        label="File under Parent Source"
                        :id="formData.parent_id"
                        :items="sourceList"
                        @changed="(val) => (formData.parent_id = val)"
                      ></Autocomplete>
                    </div>
                    <div
                      class="col-sm-6 q-px-sm"
                      v-if="formData.type == 'scale'"
                    >
                      <q-input
                        v-model="formData.rank"
                        label="Rank"
                        hint="This field will rank the Scale Question in order, 1 onwards"
                      >
                      </q-input>
                    </div>
                    <div class="col-12 col-sm-6 q-px-sm">
                      <q-select
                        :options="['draft', 'live']"
                        v-model="formData.status"
                        label="Status"
                      ></q-select>
                    </div>
                    <div class="col-12">
                      <q-checkbox
                        v-model="formData.negative"
                        label="Negative Source"
                        :true-value="1"
                        :false-value="0"
                      ></q-checkbox>
                      <q-btn
                        v-if="formData.id"
                        label="Duplicate Positive Source"
                        flat
                        :loading="creatingPositiveSourceLoading"
                        class="bg-primary q-ml-md text-white"
                        @click="createPositiveSource(formData.id)"
                      ></q-btn>
                    </div>

                    <div class="col-12">
                      <q-input
                        label="Question (Scale Only)"
                        v-model="formData.question"
                        v-if="formData.type == 'scale'"
                        type="textarea"
                        class="q-mb-lg"
                      >
                      </q-input>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <q-input
                    label="Admin Notes"
                    v-model="formData.adminNotes"
                    type="textarea"
                    class="q-mb-lg"
                  >
                  </q-input>
                </div>
                <div class="col-12">
                  <p class="text-bold">Info Blurb (Side Popout)</p>
                  <q-editor
                    v-model="formData.infoBlurb"
                    :dense="$q.screen.lt.md"
                    :toolbar="[
                      [
                        {
                          label: $q.lang.editor.align,
                          icon: $q.iconSet.editor.align,
                          fixedLabel: true,
                          options: ['left', 'center', 'right', 'justify'],
                        },
                      ],
                      [
                        'bold',
                        'italic',
                        'strike',
                        'underline',
                        'subscript',
                        'superscript',
                      ],
                      ['token', 'hr', 'link', 'custom_btn'],
                      ['print', 'fullscreen'],
                      [
                        {
                          label: $q.lang.editor.formatting,
                          icon: $q.iconSet.editor.formatting,
                          list: 'no-icons',
                          options: [
                            'p',
                            'h1',
                            'h2',
                            'h3',
                            'h4',
                            'h5',
                            'h6',
                            'code',
                          ],
                        },
                        {
                          label: $q.lang.editor.fontSize,
                          icon: $q.iconSet.editor.fontSize,
                          fixedLabel: true,
                          fixedIcon: true,
                          list: 'no-icons',
                          options: [
                            'size-1',
                            'size-2',
                            'size-3',
                            'size-4',
                            'size-5',
                            'size-6',
                            'size-7',
                          ],
                        },

                        'removeFormat',
                      ],
                      ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                      ['undo', 'redo'],
                      ['viewsource'],
                    ]"
                  />
                </div>
              </div>
            </q-form>

            <!-- <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="col-3">
                    <div class="title q-my-none">Pre-Written Goal</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row q-my-sm">
              <div>
                <div
                  v-if="
                    (changeImage || !basicGoalFormData.basicGoalImageUrl) &&
                    basicGoalFormData.id
                  "
                >
                  <div style="width: 200px">
                    <croppa
                      ref="imgCroppa"
                      :height="200"
                      :width="300"
                      v-model="myCroppa"
                      remove-button-color="#68c6d2"
                      :show-loading="true"
                      :loading-size="50"
                      crossOrigin="anonymous"
                      :quality="2"
                      :prevent-white-space="false"
                    ></croppa>
                  </div>
                  <div class="row">
                    <span class="text-caption">
                      (this is the image used as the default when a user selects
                      this goal from Upstream's list )
                    </span>
                  </div>
                  <div class="row">
                    <span class="text-caption"
                      >Recommended .jpg/.jpeg files and ideally 500Kb
                    </span>
                  </div>
                </div>

                <div v-else style="margin: auto; width: 300px">
                  <q-img
                    :src="basicGoalFormData.basicGoalImageUrl"
                    style="width: 300px; height: 200px"
                    v-if="formData.id"
                  >
                  </q-img>
                  <q-btn
                    class="full-width"
                    color="primary"
                    label="Change"
                    @click="changeImage = true"
                    v-if="basicGoalFormData.id"
                  >
                  </q-btn>

                  <div class="row">
                    <span class="text-caption">
                      (this is the image used as the default when a user selects
                      this goal from Upstream's list )
                    </span>
                  </div>
                  <div class="row">
                    <span class="text-caption"
                      >Recommended .jpg/.jpeg files and ideally 500Kb
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <q-form ref="basicGoalForm">
              <div class="row q-col-gutter-x-md">
                <div class="col-4">
                  <q-input
                    label="Pre-Written Goal Entry"
                    v-model="basicGoalFormData.basicGoalAction"
                    hint="Pre-Written Goal Entry
                  Please written the full sentence of the
                pre-written goal you want as a selectable option"
                    :rules="[(v) => !!v || 'Field is Required']"
                  >
                  </q-input>
                </div>

                <div class="col-4">
                  <q-input
                    label="Coloured Text"
                    v-model="basicGoalFormData.basicGoal"
                    hint="Please copy and match the word in
                      the sentence of your Pre-Written Goal,
                    to what word will be changed to a special colour"
                    :rules="[(v) => !!v || 'Field is Required']"
                  ></q-input>
                </div>
                <div class="col-4">
                  <div class="row">
                    <span class="text-grey"> Text Preview </span>
                  </div>
                  <div class="row" v-if="basicGoalFormData.basicGoalAction">
                    <div
                      v-for="(
                        text, i
                      ) in basicGoalFormData.basicGoalAction.split(' ')"
                      :key="i"
                      class="previewGoalText"
                      :class="`${i > 0 ? 'q-ml-xs' : ''} ${
                        isTextColored(text, basicGoalFormData.basicGoal)
                          ? 'text-primary'
                          : ''
                      }`"
                    >
                      {{ text }}
                    </div>
                  </div>
                </div>
              </div>
            </q-form> -->
          </q-tab-panel>
          <!--UNITS-->
          <!-- <q-tab-panel name="units">
            <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="title q-my-none q-mx-none">Units</div>

                  <div style="width: 200px">
                    <q-form ref="unitForm">
                      <q-input v-model="unitFormData.unit" label="Unit">
                      </q-input>
                    </q-form>
                  </div>
                  <div>
                    <q-btn
                      :disabled="!unitFormData.unit"
                      color="primary"
                      @click="addUnit"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="unitsSearch"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <data-table
              style="height: calc(100vh - 270px)"
              headerBgColor="#162c47"
              headerTextColor="white"
              :columns="unitsColumns"
              :data="unitsList"
              flat
              :filter="unitsSearch"
            >
              <template slot="body-cell-units" slot-scope="data">
                <q-td :props="data.props">
                  <q-input
                    style="max-width: 400px"
                    dense
                    color="accent"
                    @blur="saveUnit(data.props.row)"
                    label="Unit"
                    v-model="data.props.row.unit"
                  >
                  </q-input>
                </q-td>
              </template>
              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    round
                    color="red"
                    flat
                    icon="mdi-delete"
                    @click="removeUnit(data.props.row)"
                    size="md"
                    class="float-right"
                  >
                    <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                      Remove Outcome
                    </q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </data-table>
          </q-tab-panel> -->
          <!---OUTCOMES-->
          <q-tab-panel name="outcomes">
            <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="title q-my-none q-mx-none">Outcomes</div>

                  <div style="width: 200px">
                    <q-form ref="outcomeForm">
                      <q-select
                        :options="filteredOutcomesList"
                        v-model="selectedOutcome"
                        label="Outcome"
                        map-options
                        emit-value
                        option-value="id"
                        option-label="name"
                      >
                      </q-select>
                    </q-form>
                  </div>
                  <div>
                    <q-btn
                      :disabled="!selectedOutcome"
                      color="primary"
                      @click="addOutcome"
                    >
                      <q-icon name="mdi-plus-circle"></q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchText"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <data-table
              style="height: calc(100vh - 270px)"
              headerBgColor="#162c47"
              headerTextColor="white"
              v-if="
                outcomesSourcesList.length == 0 ||
                outcomesSourcesList[0].sources_id == formData.id
              "
              :columns="columns"
              :data="outcomesSourcesList"
              flat
              :filter="searchText"
            >
              <template slot="body-cell-categoryName" slot-scope="data">
                <q-td :props="data.props">
                  <q-select
                    style="max-width: 400px"
                    use-input
                    fill-input
                    dense
                    hide-selected
                    color="accent"
                    @blur="
                      submitCategory(
                        data.props.row,
                        data.props.row.categoryName
                      )
                    "
                    @popup-show="filterCategoryOptionsByOutcome(data.props.row)"
                    input-debounce="0"
                    label="Category"
                    v-model="data.props.row.categoryName"
                    :options="categoryOptions"
                    @filter="
                      (val, update, abort) =>
                        filterCategory(val, update, abort, data.props.row)
                    "
                    map-options
                    emit-value
                    option-label="name"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </q-td>
              </template>
              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    round
                    color="red"
                    flat
                    icon="mdi-delete"
                    @click="removeOutcome(data.props.row)"
                    size="md"
                    class="float-right"
                  >
                    <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                      Remove Outcome
                    </q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </data-table>
          </q-tab-panel>
          <q-tab-panel name="reference">
            <div v-if="!isAddingReference">
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div class="title q-my-none q-mx-none">Reference</div>

                    <div>
                      <q-btn color="primary" @click="isAddingReference = true">
                        <q-icon name="mdi-plus-circle"></q-icon>
                        <span class="sustainability-font q-mx-sm"> Add </span>
                      </q-btn>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <q-input
                    class="searchbar float-right"
                    style="max-width: 70%"
                    filled
                    v-model="referenceSearchText"
                    debounce="200"
                    label="Search"
                    clearable
                    dense
                  >
                    <template #prepend>
                      <q-icon name="mdi-magnify"></q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
              <data-table
                style="height: calc(100vh - 270px)"
                :columns="referenceColumns"
                :filter="referenceSearchText"
                :data="referenceList"
                @rowDoubleClick="referenceDoubleClick"
                headerBgColor="#162c47"
                headerTextColor="white"
              >
                <template slot="body-cell-actions" slot-scope="data">
                  <q-td :props="data.props">
                    <q-btn
                      round
                      color="red"
                      flat
                      icon="mdi-delete"
                      @click="removeReference(data.props.row)"
                      size="md"
                      class="float-right"
                    >
                      <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                        Remove Reference
                      </q-tooltip>
                    </q-btn>
                  </q-td>
                </template>
              </data-table>
            </div>
            <div v-else>
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div>
                      <q-btn flat @click="backFromReferenceForm">
                        <q-icon name="mdi-arrow-left"></q-icon>
                      </q-btn>
                    </div>
                    <div class="title q-my-none q-mx-none">Reference</div>
                  </div>
                </div>
              </div>
              <div class="row q-mt-lg">
                <div class="col-12">
                  <reference-form
                    @closeForm="backFromReferenceForm"
                  ></reference-form>
                </div>
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="solutions">
            <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="title q-my-none q-mx-none">Solutions</div>

                  <div style="width: 200px">
                    <q-form ref="outcomeForm">
                      <q-select
                        :options="filteredSolutionsOptions"
                        v-model="selectedSolution"
                        label="Solution"
                        use-input
                        fill-input
                        hide-selected
                        @filter="solutionFilterFn"
                        map-options
                        emit-value
                        option-value="id"
                        option-label="title"
                      >
                      </q-select>
                    </q-form>
                  </div>
                  <div>
                    <q-btn
                      :disabled="!selectedSolution"
                      color="primary"
                      @click="addSolutionSources"
                    >
                      <q-icon name="mdi-plus-circle"></q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchText"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <data-table
              style="height: calc(100vh - 270px)"
              headerBgColor="#162c47"
              headerTextColor="white"
              :columns="solutionsColumns"
              :data="solutionsList"
              flat
              :filter="searchText"
            >
              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    round
                    color="red"
                    flat
                    icon="mdi-delete"
                    @click="removeSolutionSources(data.props.row)"
                    size="md"
                    class="float-right"
                  >
                    <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                      Remove Solution
                    </q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </data-table>
          </q-tab-panel>
          <q-tab-panel name="scaleNotes">
            <div class="row q-my-sm">
              <div class="col-12 col-md-6 q-px-sm">
                <p class="text-bold">Scale Level 1 Note</p>
                <q-editor
                  v-model="formData.scaleLevel1Notes"
                  :dense="$q.screen.lt.md"
                  :toolbar="[
                    [
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        list: 'only-icons',
                        options: ['left', 'center', 'right', 'justify'],
                      },
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        options: ['left', 'center', 'right', 'justify'],
                      },
                    ],
                    [
                      'bold',
                      'italic',
                      'strike',
                      'underline',
                      'subscript',
                      'superscript',
                    ],
                    ['token', 'hr', 'link', 'custom_btn'],
                    ['print', 'fullscreen'],
                    [
                      {
                        label: $q.lang.editor.formatting,
                        icon: $q.iconSet.editor.formatting,
                        list: 'no-icons',
                        options: [
                          'p',
                          'h1',
                          'h2',
                          'h3',
                          'h4',
                          'h5',
                          'h6',
                          'code',
                        ],
                      },
                      {
                        label: $q.lang.editor.fontSize,
                        icon: $q.iconSet.editor.fontSize,
                        fixedLabel: true,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'size-1',
                          'size-2',
                          'size-3',
                          'size-4',
                          'size-5',
                          'size-6',
                          'size-7',
                        ],
                      },
                      {
                        label: $q.lang.editor.defaultFont,
                        icon: $q.iconSet.editor.font,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'default_font',
                          'arial',
                          'arial_black',
                          'comic_sans',
                          'courier_new',
                          'impact',
                          'lucida_grande',
                          'times_new_roman',
                          'verdana',
                        ],
                      },
                      'removeFormat',
                    ],
                    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                    ['undo', 'redo'],
                    ['viewsource'],
                  ]"
                  :fonts="{
                    arial: 'Arial',
                    arial_black: 'Arial Black',
                    comic_sans: 'Comic Sans MS',
                    courier_new: 'Courier New',
                    impact: 'Impact',
                    lucida_grande: 'Lucida Grande',
                    times_new_roman: 'Times New Roman',
                    verdana: 'Verdana',
                  }"
                />
              </div>
              <div class="col-12 col-md-6 q-px-sm">
                <p class="text-bold">Scale Level 2 Note</p>
                <q-editor
                  v-model="formData.scaleLevel2Notes"
                  :dense="$q.screen.lt.md"
                  :toolbar="[
                    [
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        list: 'only-icons',
                        options: ['left', 'center', 'right', 'justify'],
                      },
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        options: ['left', 'center', 'right', 'justify'],
                      },
                    ],
                    [
                      'bold',
                      'italic',
                      'strike',
                      'underline',
                      'subscript',
                      'superscript',
                    ],
                    ['token', 'hr', 'link', 'custom_btn'],
                    ['print', 'fullscreen'],
                    [
                      {
                        label: $q.lang.editor.formatting,
                        icon: $q.iconSet.editor.formatting,
                        list: 'no-icons',
                        options: [
                          'p',
                          'h1',
                          'h2',
                          'h3',
                          'h4',
                          'h5',
                          'h6',
                          'code',
                        ],
                      },
                      {
                        label: $q.lang.editor.fontSize,
                        icon: $q.iconSet.editor.fontSize,
                        fixedLabel: true,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'size-1',
                          'size-2',
                          'size-3',
                          'size-4',
                          'size-5',
                          'size-6',
                          'size-7',
                        ],
                      },
                      {
                        label: $q.lang.editor.defaultFont,
                        icon: $q.iconSet.editor.font,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'default_font',
                          'arial',
                          'arial_black',
                          'comic_sans',
                          'courier_new',
                          'impact',
                          'lucida_grande',
                          'times_new_roman',
                          'verdana',
                        ],
                      },
                      'removeFormat',
                    ],
                    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                    ['undo', 'redo'],
                    ['viewsource'],
                  ]"
                  :fonts="{
                    arial: 'Arial',
                    arial_black: 'Arial Black',
                    comic_sans: 'Comic Sans MS',
                    courier_new: 'Courier New',
                    impact: 'Impact',
                    lucida_grande: 'Lucida Grande',
                    times_new_roman: 'Times New Roman',
                    verdana: 'Verdana',
                  }"
                />
              </div>
              <div class="col-12 col-md-6 q-px-sm">
                <p class="text-bold">Scale Level 3 Note</p>
                <q-editor
                  v-model="formData.scaleLevel3Notes"
                  :dense="$q.screen.lt.md"
                  :toolbar="[
                    [
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        list: 'only-icons',
                        options: ['left', 'center', 'right', 'justify'],
                      },
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        options: ['left', 'center', 'right', 'justify'],
                      },
                    ],
                    [
                      'bold',
                      'italic',
                      'strike',
                      'underline',
                      'subscript',
                      'superscript',
                    ],
                    ['token', 'hr', 'link', 'custom_btn'],
                    ['print', 'fullscreen'],
                    [
                      {
                        label: $q.lang.editor.formatting,
                        icon: $q.iconSet.editor.formatting,
                        list: 'no-icons',
                        options: [
                          'p',
                          'h1',
                          'h2',
                          'h3',
                          'h4',
                          'h5',
                          'h6',
                          'code',
                        ],
                      },
                      {
                        label: $q.lang.editor.fontSize,
                        icon: $q.iconSet.editor.fontSize,
                        fixedLabel: true,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'size-1',
                          'size-2',
                          'size-3',
                          'size-4',
                          'size-5',
                          'size-6',
                          'size-7',
                        ],
                      },
                      {
                        label: $q.lang.editor.defaultFont,
                        icon: $q.iconSet.editor.font,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'default_font',
                          'arial',
                          'arial_black',
                          'comic_sans',
                          'courier_new',
                          'impact',
                          'lucida_grande',
                          'times_new_roman',
                          'verdana',
                        ],
                      },
                      'removeFormat',
                    ],
                    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                    ['undo', 'redo'],
                    ['viewsource'],
                  ]"
                  :fonts="{
                    arial: 'Arial',
                    arial_black: 'Arial Black',
                    comic_sans: 'Comic Sans MS',
                    courier_new: 'Courier New',
                    impact: 'Impact',
                    lucida_grande: 'Lucida Grande',
                    times_new_roman: 'Times New Roman',
                    verdana: 'Verdana',
                  }"
                />
              </div>
              <div class="col-12 col-md-6 q-px-sm">
                <p class="text-bold">Scale Level 4 Note</p>
                <q-editor
                  v-model="formData.scaleLevel4Notes"
                  :dense="$q.screen.lt.md"
                  :toolbar="[
                    [
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        list: 'only-icons',
                        options: ['left', 'center', 'right', 'justify'],
                      },
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        options: ['left', 'center', 'right', 'justify'],
                      },
                    ],
                    [
                      'bold',
                      'italic',
                      'strike',
                      'underline',
                      'subscript',
                      'superscript',
                    ],
                    ['token', 'hr', 'link', 'custom_btn'],
                    ['print', 'fullscreen'],
                    [
                      {
                        label: $q.lang.editor.formatting,
                        icon: $q.iconSet.editor.formatting,
                        list: 'no-icons',
                        options: [
                          'p',
                          'h1',
                          'h2',
                          'h3',
                          'h4',
                          'h5',
                          'h6',
                          'code',
                        ],
                      },
                      {
                        label: $q.lang.editor.fontSize,
                        icon: $q.iconSet.editor.fontSize,
                        fixedLabel: true,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'size-1',
                          'size-2',
                          'size-3',
                          'size-4',
                          'size-5',
                          'size-6',
                          'size-7',
                        ],
                      },
                      {
                        label: $q.lang.editor.defaultFont,
                        icon: $q.iconSet.editor.font,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'default_font',
                          'arial',
                          'arial_black',
                          'comic_sans',
                          'courier_new',
                          'impact',
                          'lucida_grande',
                          'times_new_roman',
                          'verdana',
                        ],
                      },
                      'removeFormat',
                    ],
                    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                    ['undo', 'redo'],
                    ['viewsource'],
                  ]"
                  :fonts="{
                    arial: 'Arial',
                    arial_black: 'Arial Black',
                    comic_sans: 'Comic Sans MS',
                    courier_new: 'Courier New',
                    impact: 'Impact',
                    lucida_grande: 'Lucida Grande',
                    times_new_roman: 'Times New Roman',
                    verdana: 'Verdana',
                  }"
                />
              </div>
              <div class="col-12 col-md-6 q-px-sm">
                <p class="text-bold">Scale Level 5 Note</p>
                <q-editor
                  v-model="formData.scaleLevel5Notes"
                  :dense="$q.screen.lt.md"
                  :toolbar="[
                    [
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        list: 'only-icons',
                        options: ['left', 'center', 'right', 'justify'],
                      },
                      {
                        label: $q.lang.editor.align,
                        icon: $q.iconSet.editor.align,
                        fixedLabel: true,
                        options: ['left', 'center', 'right', 'justify'],
                      },
                    ],
                    [
                      'bold',
                      'italic',
                      'strike',
                      'underline',
                      'subscript',
                      'superscript',
                    ],
                    ['token', 'hr', 'link', 'custom_btn'],
                    ['print', 'fullscreen'],
                    [
                      {
                        label: $q.lang.editor.formatting,
                        icon: $q.iconSet.editor.formatting,
                        list: 'no-icons',
                        options: [
                          'p',
                          'h1',
                          'h2',
                          'h3',
                          'h4',
                          'h5',
                          'h6',
                          'code',
                        ],
                      },
                      {
                        label: $q.lang.editor.fontSize,
                        icon: $q.iconSet.editor.fontSize,
                        fixedLabel: true,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'size-1',
                          'size-2',
                          'size-3',
                          'size-4',
                          'size-5',
                          'size-6',
                          'size-7',
                        ],
                      },
                      {
                        label: $q.lang.editor.defaultFont,
                        icon: $q.iconSet.editor.font,
                        fixedIcon: true,
                        list: 'no-icons',
                        options: [
                          'default_font',
                          'arial',
                          'arial_black',
                          'comic_sans',
                          'courier_new',
                          'impact',
                          'lucida_grande',
                          'times_new_roman',
                          'verdana',
                        ],
                      },
                      'removeFormat',
                    ],
                    ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                    ['undo', 'redo'],
                    ['viewsource'],
                  ]"
                  :fonts="{
                    arial: 'Arial',
                    arial_black: 'Arial Black',
                    comic_sans: 'Comic Sans MS',
                    courier_new: 'Courier New',
                    impact: 'Impact',
                    lucida_grande: 'Lucida Grande',
                    times_new_roman: 'Times New Roman',
                    verdana: 'Verdana',
                  }"
                />
              </div>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import DataTable from "@/components/datatable/datatable.vue";
  import SustainabilityDatatable from "@/components/datatable/sustainabilityDatatable.vue";
  import ReferenceForm from "@/components/sources/referenceForm/referenceForm.vue";
  import Autocomplete from "@/components/autocomplete/autocomplete.vue";

  export default {
    components: {
      DataTable,
      SustainabilityDatatable,
      ReferenceForm,
      Autocomplete,
    },
    computed: {
      ...mapGetters({
        data: "sources/selectedSource",
        outcomesSourcesList: "outcomes/outcomesSourcesList",
        outcomesList: "outcomes/list",
        outcomesCategories: "outcomes/outcomesCategories",
        unitsList: "units/list",
        selectedBasicGoal: "basicGoals/current",
        referenceList: "sources/emissionsFactor/list",
        solutionsList: "sources/solutions/list",
        solutionsOptionsList: "solutions/list",
        sourceList: "sources/list",
      }),
      filteredOutcomesList() {
        return this.outcomesList.filter((e) => {
          if (
            this.outcomesSourcesList.findIndex((os) => e.id == os.outcomes_id) < 0
          ) {
            return e;
          }
        });
      },
      // isTiedToCarbon() {
      //   if (this.outcomesSourcesList.length > 0) {
      //     if (
      //       this.outcomesSourcesList.findIndex((e) => e.outcomes_id == 1) > -1
      //     ) {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   } else {
      //     return false;
      //   }
      // },
      //outcomes table
      columns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "outcomeName",
            label: "Outcome Name",
            align: "left",
            field: "outcomeName",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "categoryName",
            label: "Category Name",
            align: "left",
            field: "categoryName",
            style:
              "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },

          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
      //solutions table
      solutionsColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "title",
            label: "title",
            align: "left",
            field: "title",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
      unitsColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "units",
            label: "Unit",
            align: "left",
            field: "unit",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
      referenceColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "factor",
            label: "Factor",
            align: "left",
            field: "emissionsFactor",
            sortable: true,
          },
          {
            name: "unit",
            label: "Unit",
            align: "left",
            field: "unit",
            sortable: true,
          },
          {
            name: "url",
            label: "Url",
            align: "left",
            field: "url",
            sortable: true,
          },
          {
            name: "createdAt",
            label: "Created At",
            align: "left",
            field: "created_at",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
    },
    props: {
      newSource: {
        type: Boolean,
        default: false,
      },
      section_id: {
        type: Number,
        default: null,
      },
    },
    watch: {
      $route: {
        handler() {
          this.handleRoute();
        },
        deep: true,
      },
      outcomesSourcesList: {
        deep: true,
        handler() {
          this.filterTabs();
        },
      },
      data: {
        deep: true,
        handler() {
          this.init();
        },
      },
      selectedBasicGoal: {
        handler() {
          this.initBasicGoal();
        },
        deep: true,
      },
      unitsList: {
        deep: true,
        handler() {
          this.filteredUnitsList = this.unitsList;
        },
      },
    },
    data: () => ({
      //tab
      tab: "general",
      initTabs: [
        {
          name: "general",
          label: "Source Specific",
          isError: false,
        },
        {
          name: "outcomes",
          label: "Outcomes",
          isError: false,
        },
        {
          name: "reference",
          label: "Factors",
          isError: false,
        },
        {
          name: "solutions",
          label: "Solutions",
          isError: false,
        },
        {
          name: "scaleNotes",
          label: "Scale Notes",
          isError: false,
        },

        // {
        //   name: "solutions",
        //   label: "Solutions",
        //   isError: false,
        // },
      ],
      tabsList: [],

      //table
      searchText: "",

      // sourceForm
      formData: {
        status: "draft",
        basicGoal: "",
        sourceUnits_id: "",
        infoBlurb: "",
        scaleLevel1Notes: "",
        scaleLevel2Notes: "",
        scaleLevel3Notes: "",
        scaleLevel4Notes: "",
        scaleLevel5Notes: "",
        negative: 1,
      },

      //basicGoal
      basicGoalFormData: {
        basicGoal: "",
      },
      //status options
      status: ["draft", "live"],

      //outcomeForm
      selectedOutcome: "",

      //category
      categoryOptions: [],

      //solutionForm
      solutionFormData: {
        title: "",
        description: "",
      },

      //units
      unitsSearch: "",
      unitFormData: {
        unit: "",
      },
      filteredUnitsList: [],

      isLoading: false,

      //croppa
      myCroppa: {},
      changeImage: false,

      sourceMyCroppa: {},
      sourceChangeImage: false,

      //reference
      referenceSearchText: "",
      isAddingReference: false,

      //solutions
      selectedSolution: null,
      filteredSolutionsOptions: [],

      creatingPositiveSourceLoading: false,
    }),
    async mounted() {
      if (this.$route.name == "sourcesView") {
        await this.tabTraversal();
      }
      this.handleRoute();
      this.init();
      this.initBasicGoal();
    },
    methods: {
      filterTabs() {
        this.tabsList = this.initTabs;
      },
      isTextColored(currentText, TextToBeColored) {
        if (TextToBeColored) {
          let textToBeColoredArray = TextToBeColored.split(" ");
          if (textToBeColoredArray.includes(currentText)) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      solutionFilterFn(val, update, abort) {
        update(() => {
          const needle = val.toLocaleLowerCase();
          let solutionIDList = this.solutionsList.map((e) => e.id);

          this.filteredSolutionsOptions = this.solutionsOptionsList.filter(
            (e) =>
              e.title.toLocaleLowerCase().indexOf(needle) > -1 &&
              !solutionIDList.includes(e.id)
          );
        });
      },
      setSelectedSolution(val) {
        this.selectedSolution = val;
      },
      async addSolutionSources() {
        let solutionsSources = {
          solutions_id: this.selectedSolution,
          sources_id: this.data.id,
        };
        let result = await this.$store.dispatch(
          "sources/solutions/new",
          solutionsSources
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.selectedSolution = "";
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      async tabTraversal() {
        let tabNames = ["general", "outcomes"];
        await tabNames.reduce((promiseChain, item) => {
          return promiseChain.then(
            () =>
              new Promise((resolve) => {
                resolve();
                this.$refs.tabs.goTo(item);
              })
          );
        }, Promise.resolve());
        this.$refs.tabs.goTo("general");
      },
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
          if (this.formData.status == "temp") {
            this.formData.status = "draft";
          }

          this.formData.scaleLevel1Notes = this.formData.scaleLevel1Notes
            ? this.formData.scaleLevel1Notes
            : "";
          this.formData.scaleLevel2Notes = this.formData.scaleLevel2Notes
            ? this.formData.scaleLevel2Notes
            : "";
          this.formData.scaleLevel3Notes = this.formData.scaleLevel3Notes
            ? this.formData.scaleLevel3Notes
            : "";
          this.formData.scaleLevel4Notes = this.formData.scaleLevel4Notes
            ? this.formData.scaleLevel4Notes
            : "";
          this.formData.scaleLevel5Notes = this.formData.scaleLevel5Notes
            ? this.formData.scaleLevel5Notes
            : "";

          this.filterTabs();
        }
      },
      initBasicGoal() {
        if (this.selectedBasicGoal != null) {
          this.basicGoalFormData = JSON.parse(
            JSON.stringify(this.selectedBasicGoal)
          );
        } else {
          this.basicGoalGormData = {};
        }
      },
      closeDialog() {
        this.$store.commit("sources/setSelectedSource", null);
        this.$router.push("/sources");
        this.$emit("closeDialog");
      },
      filterCategory(val, update, abort, row) {
        update(() => {
          const category = val.toLowerCase();
          this.categoryOptions = this.outcomesCategories.filter(
            (cat) =>
              cat.name.toLowerCase().indexOf(category) > -1 &&
              cat.outcomes_id == row.outcomes_id
          );
        });
      },
      filterCategoryOptionsByOutcome(value) {
        this.categoryOptions = this.outcomesCategories.filter(
          (cat) => cat.outcomes_id == value.outcomes_id
        );
      },
      filterUnits(val, update) {
        update(() => {
          const unit = val.toLowerCase();
          this.filteredUnitsList = this.unitsList.filter(
            (u) => u.name.toLowerCase().indexOf(unit) > -1
          );
        });
      },
      backFromReferenceForm() {
        if (this.$route.name != "sourcesView") {
          this.$router.push("/sources/" + this.$route.params.id);
        }
        this.isAddingReference = false;
        this.$store.commit("sources/emissionsFactor/setSelectedReference", null);
      },
      async removeOutcome(outcome) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let removedOutcome = {
              ...outcome,
              deleted_at: Date.now(),
            };
            let result = await this.$store.dispatch(
              "outcomes/saveOutcomesSources",
              removedOutcome
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          }
        });
      },
      async removeSolutionSources(row) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let removedSolution = {
              id: row.solutionsSources_id,
              sources_id: row.sources_id,
              deleted_at: Date.now(),
            };
            let result = await this.$store.dispatch(
              "sources/solutions/save",
              removedSolution
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          }
        });
      },
      removeReference(row) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let removedReference = {
              ...row,
              deleted_at: Date.now(),
            };
            let result = await this.$store.dispatch(
              "sources/emissionsFactor/save",
              removedReference
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          }
        });
      },
      referenceDoubleClick(row) {
        this.$router.push(this.$route.path + "/" + row.id);
      },
      async handleRoute() {
        if (this.$route.params.hasOwnProperty("referenceID")) {
          this.isAddingReference = true;
          this.$refs.tabs.goTo("reference");
        }
      },
      async addOutcome() {
        const isValid = await this.$refs.outcomeForm.validate();
        if (isValid) {
          let outcomesSourcesPayload = {
            outcomes_id: this.selectedOutcome,
            sources_id: this.data.id,
          };
          let result = await this.$store.dispatch(
            "outcomes/newOutcomesSources",
            outcomesSourcesPayload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.selectedOutcome = "";
            this.$refs.outcomeForm.reset();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async saveBasicGoal() {
        let payload = {
          ...this.basicGoalFormData,
          sources_id: this.$route.params.id,
          status: "live",
        };
        //image uploading
        if (this.myCroppa && this.myCroppa.imageSet) {
          payload.basicGoalImage = {
            dataUrl: this.myCroppa.generateDataUrl(),
          };
        } else {
          delete payload.basicGoalImage;
        }

        let result = await this.$store.dispatch("basicGoals/save", payload);
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      async createBasicGoal() {
        let payload = {
          ...this.basicGoalFormData,
          sources_id: this.$route.params.id,
        };
        //image uploading
        if (this.myCroppa && this.myCroppa.imageSet) {
          payload.basicGoalImage = {
            dataUrl: this.myCroppa.generateDataUrl(),
          };
        } else {
          delete payload.basicGoalImage;
        }

        let result = this.$store.dispatch("basicGoals/new", payload);
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      async save(isClose, isAddNew) {
        //source validation
        let result = await this.update();
        let tabIndexGeneral = this.tabsList.findIndex((e) => e.name == "general");
        let tabIndexOutcomes = this.tabsList.findIndex(
          (e) => e.name == "outcomes"
        );
        if (tabIndexGeneral > -1) {
          if (result == "validation failed") {
            this.tabsList[tabIndexGeneral].isError = true;
            return;
          } else {
            this.tabsList[tabIndexGeneral].isError = false;
          }
        }
        if (tabIndexOutcomes > -1) {
          if (result == "outcome required") {
            this.tabsList[tabIndexOutcomes].isError = true;
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "At least 1 Outcome is required.",
            });
            return;
          } else {
            this.tabsList[tabIndexOutcomes].isError = false;
          }
        }

        //saving and adding basic goal
        // let isBasicGoalValid = await this.$refs.basicGoalForm.validate();
        // if (isBasicGoalValid) {
        //   this.saveBasicGoal();
        // }

        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
        if (isClose && !isAddNew) {
          this.closeDialog();
        }

        if (isAddNew && !isClose) {
          this.addNew();
        }
      },
      async addNew() {
        this.isLoading = true;
        let result = await this.$store.dispatch("sources/new", {
          status: "temp",
        });
        let id = result.Response.newSourceId;
        await this.$store.dispatch("sources/loadSourceByID", id);
        await this.$store.dispatch("outcomes/loadOutcomesSourcesBySourceID", id);
        this.$router.push("/sources/" + parseFloat(id));
        this.init();
        this.tab = "general";
        this.isLoading = false;
      },
      async submitCategory(outcomesSource, category) {
        if (category) {
          let outcomesSourcePayload = {
            ...outcomesSource,
            categories_id: category.id,
          };
          delete outcomesSourcePayload["categoryName"];
          let result = await this.$store.dispatch(
            "outcomes/saveOutcomesSources",
            outcomesSourcePayload
          );
          this.$store.dispatch(
            "outcomes/loadOutcomesSourcesBySourceID",
            outcomesSourcePayload.sources_id
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async updateCategory(outcomesSource, category) {
        let categoryPayload = {
          ...outcomesSource,
        };
        if (category == "" || !category) {
          categoryPayload["deleteCategory"] = true;
        }
        let result = await this.$store.dispatch(
          "outcomes/saveOutcomesCategory",
          categoryPayload
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      async createCategory(outcomesSource, category) {
        if (category != "" && category) {
          let categoryPayload = {
            ...outcomesSource,
          };
          categoryPayload["categoryName"] = category;
          let result = await this.$store.dispatch(
            "outcomes/newOutcomesCategory",
            categoryPayload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async update() {
        this.$emit("loadingStateChanged", true);
        const isValid = await this.$refs.form.validate();
        if (this.outcomesSourcesList.length <= 0) {
          this.$emit("loadingStateChanged", false);
          return "outcome required";
        }
        if (isValid) {
          let payload = { ...this.formData };
          //image uploading
          if (this.sourceMyCroppa && this.sourceMyCroppa.imageSet) {
            payload.imageUrl = {
              dataUrl: this.sourceMyCroppa.generateDataUrl(),
            };
          } else {
            delete payload.imageUrl;
          }

          let result = await this.$store.dispatch("sources/save", payload);
          return result;
        } else {
          this.$emit("loadingStateChanged", false);
          return "validation failed";
        }
      },
      async create() {
        this.$emit("loadingStateChanged", true);
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          this.formData.section_id = this.section_id;
          let result = await this.$store.dispatch("sources/new", this.formData);
          this.formData = {};
          return result;
        }
        this.$emit("loadingStateChanged", false);
      },
      async createPositiveSource(id) {
        this.creatingPositiveSourceLoading = true;
        try {
          let result = await this.$store.dispatch(
            "sources/createPositiveAlternative",
            { id: id }
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
        this.creatingPositiveSourceLoading = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }

  .sustainability-button {
    min-width: 151px;
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  .previewGoalText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
  }

  .tabTitle {
    font-weight: bold;
  }

  .searchbar {
    @media (max-width: 479px) {
      max-width: 115px !important;
    }
  }
</style>
